var convertMarkup = function (text) {
    return { __html: text };
};
export default convertMarkup;
